export default __webpack_public_path__ + "static/leaves-lighter-146eb2949b1254c0e0b7a89319a7b3b8.png";